import React from 'react';
import { InputGroup, FormControl, Form, Button,Dropdown } from 'react-bootstrap';
import SelectDropDownComponent from "../../layout/SelectDropDownComponent";

const SearchArticleComponent = (props) => {      
    let pageData = props.pageData; 
    const catSearch = typeof props.catSearch ==='undefined' ? true: false;
    
    let defaultValue = '';
    if(props.searchPage){
        defaultValue = props.searchOption.keyword_search;  
    }else{
        defaultValue = (props.searchOption.search_key  ==="free-text" && props.searchOption.search_value !=="") ?  props.searchOption.search_value  : ''
    }
    
    
    return (
        props.pageData ? 
          <div className="">
             {catSearch ?  <div className="text-left page-title"> 
              { pageData.pageTitle  } </div> : '' }
            
             <Form className="text-left"  data-name="freeTextSearchBtn" id="TextSearchForm" onSubmit={props.submitEvent} > 
              <Form.Label>{pageData.searchBoxLabel}</Form.Label>
              <InputGroup>
                <FormControl type="text" tabIndex="-4" autoComplete="off" name="free-text" max-length="1000" value= {defaultValue} onChange={props.changeEvent}  onBlur={props.blurEvent} onFocus={props.focusEvent}  placeholder={( typeof props.searchPlaceHolder ==="undefined" || props.searchPlaceHolder === 'default') ? pageData.searchBoxPlaceHolder : props.searchPlaceHolder} className="border border-danger freeTextSearchBtn"  data-name="freeTextSearchBtn"  /> 
                
                <InputGroup.Append data-name="freeTextSearchBtn" onKeyPress={props.submitEvent}  >
                
                <InputGroup.Text data-name="freeTextSearchBtn" onClick={props.submitEvent} tabIndex="0" className="bg-danger border border-danger search-btn"> <span id="icon_search"  data-name="freeTextSearchBtn" tabIndex="-3" onClick={props.submitEvent}></span> {/* 
<i data-name="freeTextSearchBtn" tabIndex="-3" onClick={props.submitEvent} className="fa fa-search text-white" aria-hidden="true"></i> */}
</InputGroup.Text> 
              </InputGroup.Append>
              </InputGroup>
               {/** check the search text value for validation */}
               
              {/*  { props.searchOption.search_key  ==="free-text"   && props.searchOption.search_value ===""    ? (<span className="text-danger"> Error:  {pageData.searchBoxPlaceHolder} </span>) : ''}   */}

          </Form>  
            {catSearch ? 
             <Form className="text-left" id="CatSearchForm"  data-name="catSearchBtn"  onSubmit={props.submitEvent}>
              
                <Form.Group controlId="productCategory"  >
                  <Form.Label>{pageData.prodCatLabel}</Form.Label>
                  {/* <Form.Control as="select" data-catelevel="main" tabIndex="-1" defaultValue={ props.searchOption.search_key  ==="category"   && props.searchOption.search_value !== ""  ? props.searchOption.search_value : ''} name="category" className="productCategory" onChange={props.changeEvent}>
                    <option value="">{pageData.prodCatPlaceHolder} </option>
                { pageData.categories   ? (
                      pageData.categories.map((cat, key) =>
                            <option key={key} data-catindex={key}   data-children={JSON.stringify(cat.children)} value={cat.catName}>{cat.catName}</option>
                        )
                ) : (
                      ''
                    )}

                  </Form.Control> */}
                  
                </Form.Group>
                  <Form.Group>
                  <Dropdown>
                    <Dropdown.Toggle variant="default" className="productCategory form-control" id="dropdown-basic">
                    { /* props.searchOption.search_key  ==="category"   && */ props.mainCategory !== ""  ? props.mainCategory : pageData.prodCatPlaceHolder}                  
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                    { pageData.categories   ? (
                      pageData.categories.map((cat, key) =>                      
                      <Dropdown.Item  data-catelevel="main"  data-indexc="-1" data-slug={cat.slug} data-value={cat.catName} key={key} data-catindex={key}   data-children={JSON.stringify(cat.children)} data-name="category"  onClick={props.changeEvent} className={props.mainCategory ===  cat.catName ? 'selected' : ''}>{cat.catName}</Dropdown.Item>                           
                        )
                ) : (
                      ''
                    )}
                    </Dropdown.Menu>
                  </Dropdown>
                  </Form.Group>

                  { props.subCategories.length > 0 ? (
                    props.subCategories.map((subCat, subCatIndex) =>

                  <SelectDropDownComponent  search_value={props.searchOption.search_value} defaultOption={pageData.prodSubCatPlaceHolder}  key={subCatIndex} indexKey={subCatIndex} changeEvent={props.changeEvent} options={subCat}></SelectDropDownComponent> ) ) : ''}
                  
                   
                <InputGroup className="justify-content-center searchBtnDiv">
                  <Button disabled={props.disableSearchBtn} className="bg-gray cat-search-btn" size="md" id="submitBtn" onClick={props.submitEvent} tabIndex="0"  data-name="catSearchBtn"  type="button" variant="outline-secondary">{pageData.prodCatSearchBtnValue}</Button>
                </InputGroup>          
             </Form>  : '' }
             
          </div>          
         : ''
    );
};

export default SearchArticleComponent;